import React, { useEffect } from 'react';
import { format } from 'date-fns';
import { Trans, useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import Button from 'src/components/Button/Button';
import './WithdrawModal.scss';

interface WithdrawModalProps {
  close: () => {}
}

function WithdrawModal({ close }: WithdrawModalProps) {
  const { t } = useTranslation('common');
  const location = useLocation();
  const query = new URLSearchParams(location.hash);

  const closeFunction = (e: KeyboardEvent) => {
    if (e.key === 'Enter') close();
  };

  useEffect(() => {
    document.addEventListener('keydown', closeFunction);

    return () => {
      document.removeEventListener('keydown', closeFunction);
    };
  });

  return (
    <div className="withdraw-modal">
      <div className="withdraw-modal__title">
        <Trans
          i18nKey={ 'withdrawFunds.modalTitle' }
          values={ { amount: (+query.get('amount')).toFixed(2), time: format(new Date(+query.get('date')), 'HH:mm') } }
        >
          <strong></strong>
          <br />
        </Trans>
      </div>
      <div className="withdraw-modal__sub-title">
        <Trans
          i18nKey={ 'withdrawFunds.modalSubtitle' }
          values={ { link: t('account.accountHistory') } }
        >
          <br />
          <Link to="/account/betting-history" className="withdraw-modal__link"></Link>
        </Trans>
      </div>
      <Button
        className="btn--cta withdraw-modal__close"
        onClick={ close }
      >
        { t('withdrawFunds.modalConfirm') }
      </Button>
    </div>
  );
}

export default WithdrawModal;
